import { Grid, Typography } from '@mui/material';
import { UseFormReturn } from 'react-hook-form';

import { ModulosEnumChoice, useLoaders } from '@/shared';
import { useFetchMotivosRechazo } from '@/shared/actions/erp';
import { CustomAutocomplete, CustomTextArea } from '@/shared/components/ui';
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';
import { Agendamiento, MotivoRechazo } from '@/shared/interfaces';
import { SaveFormDataAgendamiento } from '../../interface/SaveFormDataAgendamiento.interface';

export type RejectAgendaModalProps = {
  open: boolean;
  onClose: () => void;
  agendamiento: Agendamiento;
  form: UseFormReturn<SaveFormDataAgendamiento>;
  onConfirm: () => void;
};

// Solo es una solicitud de actualización - NO bloquea el flujo
const RejectAgendaModal: React.FC<RejectAgendaModalProps> = ({
  onClose,
  open,
  // preagendamiento,
  onConfirm,
  form: formRechazo,
}) => {
  ///* fetch data --------------------
  const {
    data: motivosRechazoPaging,
    isLoading: isLoadingMotivosRechazo,
    isRefetching: isRefetchingMotivosRechazo,
  } = useFetchMotivosRechazo({
    estado: true,
    modulo: ModulosEnumChoice.AGENDAMIENTO,
    page_size: 100,
  });

  ///* effects --------------------
  useLoaders(isLoadingMotivosRechazo || isRefetchingMotivosRechazo);

  return (
    <ScrollableDialogProps
      open={open}
      title="Gestión Ventas"
      minWidth="40%"
      onClose={() => {
        onClose();
        //formRechazo.setValue('isRejecting', false);
        formRechazo.reset({
          ...formRechazo.getValues(),
          motivo_rechazo: '',
          isRejecting: false,
        });
      }}
      onConfirm={onConfirm}
      confirmTextBtn="SI"
      cancelTextBtn="NO"
      confirmVariantBtn="outlined"
      contentNode={
        <Grid item container xs={12} mb={3} spacing={3}>
          <Grid item xs={12}>
            <Typography variant="body1">
              Para enviar a Gestión Ventas el agendamiento es necesario seleccionar el motivo de rechazo. 
              ¿Desea continuar?
            </Typography>
          </Grid>
          
          <CustomAutocomplete<MotivoRechazo>
            label="Motivo de rechazo"
            name="motivo_rechazo"
            // options
            options={motivosRechazoPaging?.data?.data || []}
            valueKey="nombre"
            actualValueKey="codigo"
            defaultValue={formRechazo.getValues().motivo_rechazo || ''}
            isLoadingData={
              isLoadingMotivosRechazo || isRefetchingMotivosRechazo
            }
            // validation
            control={formRechazo.control}
            error={formRechazo?.formState?.errors.motivo_rechazo}
            helperText={
              !!formRechazo?.formState?.errors.motivo_rechazo?.message &&
              'El motivo de rechazo es requerido'
            }
            disableClearable
          />
          <CustomTextArea
            label="Observación de rechazo"
            name="observacion_rechazo"
            required={false}
            control={formRechazo.control}
            error={formRechazo?.formState?.errors.observacion_rechazo}
            helperText={"Detalles adicionales sobre el rechazo"}
          />
        </Grid>
      }
    />
  );
};

export default RejectAgendaModal;
